import { OfferAvailableServiceBaggageMetadata } from "@duffel/api/types";
import { captureErrorInSentry } from "@lib/captureErrorInSentry";

export const getBaggageServiceDescription = (
  metadata: OfferAvailableServiceBaggageMetadata,
) => {
  if (!metadata) {
    captureErrorInSentry(
      new Error("getBaggageServiceDescription was not given any metadata"),
    );
    return null;
  }

  if (
    !metadata.maximum_weight_kg &&
    !metadata.maximum_length_cm &&
    !metadata.maximum_height_cm &&
    !metadata.maximum_depth_cm
  ) {
    return null;
  }

  const hasAllDimensions =
    metadata.maximum_length_cm &&
    metadata.maximum_height_cm &&
    metadata.maximum_depth_cm;

  let dimensionsLabel = "";
  if (hasAllDimensions) {
    dimensionsLabel = ` / ${metadata.maximum_height_cm} x ${metadata.maximum_length_cm} x ${metadata.maximum_depth_cm} cm`;
  }

  let weightLabel = "";
  if (metadata.maximum_weight_kg) {
    weightLabel = `Up to ${metadata.maximum_weight_kg}kg`;
  }

  return `${weightLabel}${dimensionsLabel}`;
};
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";